import React from 'react'
import { Route, RouteProps as ReactRouteProps } from 'react-router-dom'

import { ColorVariables, LayerStyles, TextStyles, Symbols } from './pages'

import { getAllTemplatesForVersionedRoute } from '@sketch/constants'

export const CwvRoutes: React.FC<ReactRouteProps> = () => {
  return (
    <>
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_SYMBOLS')}>
        <Symbols />
      </Route>
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_TEXT_STYLES')}>
        <TextStyles />
      </Route>
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_LAYER_STYLES')}>
        <LayerStyles />
      </Route>
      <Route
        exact
        path={getAllTemplatesForVersionedRoute('CWV_COLOR_VARIABLES')}
      >
        <ColorVariables />
      </Route>
    </>
  )
}
